import React from "react";

const AboutPage = () => {
  return (
    <>
      <div className="aboutDiv">
        <div className="aboutHeading">
          <h1>About Us</h1>
        </div>
        <div className="divDec">
          <p>
            The National Service Scheme (NSS) is a Central Sector Scheme of
            Government of India, Ministry of Youth Affairs & Sports. NSS B.I.T
            Sindri provides a diversified and integrated platform wherein
            students can engage in social activities apart from their academics.
            It intends to impart life skills, team spirit and social wellbeing
            in the students. It inculcates the idea of community development via
            collateral efforts of selfless volunteers.
          </p>
          <p>
            <strong>Establishment:</strong> By Ministry of Education & Culture,
            Govt. of India in collaboration with State Government in 1969 within
            37 selected Universities. NSS B.I.T Sindri was established in 2018
            and got registered in 2020. Our Professor In-Charge is Dr.
            Raghunandan Sir. NSS BIT Sindri is still strengthening its roots in
            the campus and the district.
          </p>
          <p>
            <strong>Objectives of NSS regarding Volunteers</strong>
          </p>
          <p>
            1. To make the volunteers to understand the community in which they
            work.
          </p>
          <p>
            2. To enable the volunteers to understand themselves in relation to
            their community.
          </p>
          <p>
            3. To know the needs and problems of the community and involve the
            volunteers in problem solving process that will mobilize the
            society.
          </p>
          <p>
            4. To utilize the volunteer’s knowledge in finding practical
            solution to individual or community level problems.
          </p>
          <p>
            5. To develop among the volunteers the competence required for
            group‐ living and sharing of responsibilities.
          </p>
          <p>
            6. To help the volunteers to acquire the leadership qualities for
            the improvement of democratic attitude.
          </p>
          <p>
            7. To enable the volunteers to develop capacity to meet emergencies
            and natural disasters.
          </p>
          <p>
            8. To create an awareness among the volunteers to serve the poor
            people of society.
          </p>
          <br></br>
          <p>
            <strong>Mission:</strong>
          </p>
          <p>
            <strong>
              The National Service Scheme has been functioning with the motto
              “NOT ME BUT YOU” in view of making the youth inspired in service
              of the people and hence NSS Aims Education through Community
              Service and COMMUNITY SERVICE THROUGH EDUCATION.
            </strong>
          </p>
          <p>
            1.To provide academic programs, services, facilities and
            technologies within the realm of the curricula of the affiliating
            University, that offers diverse opportunities for learning
          </p>
          <p>
            2. To create and acquire relevant knowledge along with skills and
            global competencies and disseminate the same among students.
          </p>
          <p>
            3.To promote national integration, human rights, gender equity,
            eco-consciousness and universal brotherhood.
          </p>
          <p>
            4.To uplift the socially disadvantaged sections through inclusive
            practices.
          </p>
          <br></br>
          <p>
            <strong>Vision:</strong>
          </p>
          <p>
            <strong>
              The vision is to build the youth with the mind and spirit to SERVE
              the society and work for the social uplift of the down-trodden
              masses of our nation as a movement.
            </strong>
          </p>
          <p>1.To be a vibrant and innovative center for education.</p>
          <p>
            2. To equip students with knowledge and skills in their chosen
            stream, inculcate values, identify latent talents, provide
            opportunities.
          </p>
          <p>3.To realize their full potential and make them enlightened.</p>
        </div>
      </div>
    </>
  );
};

export default AboutPage;
